function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-.009 .028)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.812 7.75a2.15 2.15 0 0 1 .666.08 2.5 2.5 0 0 1 1.482.846 21.248 21.248 0 0 1 2.6 3.71 1.83 1.83 0 0 1 .279 1.2 1.5 1.5 0 0 1-1.4 1.373 2.984 2.984 0 0 1-1.989-.318 3.74 3.74 0 0 0-.786-.368 4.118 4.118 0 0 0-1.989 0 2.616 2.616 0 0 0-.637.288 2.875 2.875 0 0 1-2.3.328 1.482 1.482 0 0 1-.995-2.049 4.974 4.974 0 0 1 .368-.766 22.988 22.988 0 0 1 2.115-3.14 2.984 2.984 0 0 1 1.99-1.144z",
  transform: "translate(-.223 -.041)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.1 3.123a4.118 4.118 0 0 1-.777 2.527 1.512 1.512 0 0 1-1.333.676 1.482 1.482 0 0 1-.995-.526 3.263 3.263 0 0 1-.885-1.82 4.466 4.466 0 0 1 .249-2.5 3.979 3.979 0 0 1 .636-.953 1.442 1.442 0 0 1 2.258 0 3.571 3.571 0 0 1 .826 1.989c0 .259.01.468.021.607z",
  transform: "translate(-.225)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9 3.163a4.059 4.059 0 0 1-.716 2.407 2.487 2.487 0 0 1-.348.378 1.413 1.413 0 0 1-1.989 0 3.163 3.163 0 0 1-.905-1.781A4.337 4.337 0 0 1 8.3 1.184 3.044 3.044 0 0 1 9 .358a1.363 1.363 0 0 1 1.9 0 3.153 3.153 0 0 1 .995 1.8 4.815 4.815 0 0 0 .005 1.005z",
  transform: "translate(-.25)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.587 4.71a1.1 1.1 0 0 1 .995.8 2.447 2.447 0 0 1 .118 1.478 3.551 3.551 0 0 1-1.582 2.358 1.413 1.413 0 0 1-.9.239 1.174 1.174 0 0 1-.995-.915 2.716 2.716 0 0 1 0-1.641 3.571 3.571 0 0 1 1.393-1.989 1.6 1.6 0 0 1 .965-.328z",
  transform: "translate(-.267 -.025)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.394 4.9a1.094 1.094 0 0 0-.994.8 2.417 2.417 0 0 0-.12 1.448 3.551 3.551 0 0 0 1.581 2.368 1.413 1.413 0 0 0 .9.229 1.164 1.164 0 0 0 .995-.915 2.726 2.726 0 0 0 0-1.641A3.511 3.511 0 0 0 2.359 5.2a1.542 1.542 0 0 0-.965-.3z",
  transform: "translate(-.21 -.026)"
}));

var SvgPawIcon = function SvgPawIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.488,
    height: 15,
    viewBox: "0 0 14.488 15",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPawIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/paw-icon.0c2cb2d0.svg";
export { ForwardRef as ReactComponent };